import {Component, OnInit} from '@angular/core';
import {NavigationService} from '../../core/services/navigation.service';
import {Router} from '@angular/router';
import {preloaderFinished} from '../../../preloader';

@Component({
    selector: 'app-test',
    templateUrl: './test.page.html',
    styleUrls: ['./test.page.scss'],
})
export class TestPage implements OnInit {

    constructor(public navigationService: NavigationService, private router: Router) {
        // if (this.navigationService.getRootPageUrl()) {
        //     this.router.navigateByUrl(this.navigationService.getRootPageUrl(),{replaceUrl:true});
        // }
    }

    ngOnInit() {
        if (this.navigationService.getRootPageUrl(true)) {
            this.router.navigateByUrl(this.navigationService.getRootPageUrl(true), {replaceUrl: true});
        } else {
            preloaderFinished();
        }
    }

}
